import { Box } from "@mui/material";
import { listFoldersInS3 } from "../api/api";
import {
  GET_LOGO,
  MAVINTERNATIONAL,
  MAVVIDYASHRAM,
} from "../../utils/const";

const HeaderComp = (props: any) => {
  const {
    year,
    setYear,
    isInternationalURL,
    onFoldersLoaded,
  } = props;

  const presentYear = new Date().getFullYear() + 1;
  let yearArray = [];
  for (let i = 1; i < 4; i++) {
    yearArray.push(presentYear - i);
  }

  const handleYearChange = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selected = event.target.value;
    if (selected !== "Select year") {
      setYear(selected);
      const response = await listFoldersInS3(selected);
      onFoldersLoaded(response);
    }
  };

  const handleLogoDisplay = () =>
    GET_LOGO(isInternationalURL ? MAVINTERNATIONAL : MAVVIDYASHRAM);

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "1em",
        }}
      >
        <img
          style={{
            width: isInternationalURL ? "20vh" : "18vh",
            textAlign: "center",
            cursor: "pointer",
          }}
          src={handleLogoDisplay()}
          onClick={() => window.location.reload()}
        />
      </div>
      <h2
        style={{
          textAlign: "center",
          fontFamily: "Inter, sans-serif",
          fontSize: "1.4em",
          fontWeight: "400",
        }}
      ></h2>
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mb: 3 }}>
        <Box
          sx={{
            fontSize: "1rem",
            fontFamily: "Inter, sans-serif",
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            color: "text.secondary",
            mb: 1,
          }}
        >
          Academic Year
        </Box>
        <select
          value={year}
          onChange={handleYearChange}
          style={{
            width: "min(360px, 85vw)",
            padding: "12px 40px 12px 16px",
            fontSize: "1.05rem",
            fontFamily: "inherit",
            color: "#1a1a2e",
            background: "#ffffff",
            border: "1.5px solid #c7c7e0",
            borderRadius: "6px",
            appearance: "none",
            WebkitAppearance: "none",
            backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24'%3E%3Cpath fill='%236b6b9a' d='M7 10l5 5 5-5z'/%3E%3C/svg%3E")`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "right 12px center",
            cursor: "pointer",
            outline: "none",
            transition: "border-color 0.2s, box-shadow 0.2s",
          }}
          onFocus={(e) => {
            e.target.style.borderColor = "#5c6bc0";
            e.target.style.boxShadow = "0 0 0 3px rgba(92,107,192,0.15)";
          }}
          onBlur={(e) => {
            e.target.style.borderColor = "#c7c7e0";
            e.target.style.boxShadow = "none";
          }}
        >
          <option value="Select year">Select year</option>
          {yearArray.map((number) => (
            <option value={number} key={number}>
              {number} – {number + 1}
            </option>
          ))}
        </select>
      </Box>
    </>
  );
};

export default HeaderComp;
